import {
  buildContentfulImageCandidateUrls,
  normalizeAssetUrl,
} from '../../../utils/contentful-image'

export function normalizeMediaUrl(rawUrl: string | undefined): string | null {
  return normalizeAssetUrl(rawUrl)
}

export function buildImageCandidateUrls(
  mediaUrl: string | null,
  contentType: string,
): string[] {
  return buildContentfulImageCandidateUrls(mediaUrl, contentType, 'full-width')
}
